import { referentialEnumToReferentialCodeList } from "@pharmupp/p3-front-commons"
import type { NewsStatusesName } from "./newsStatusesReferential"

// LabNewsStatus should implement all News Status
type LabNewsStatusEnum = Record<
  NewsStatusesName,
  { label: string; color: string; borderColor?: string }
>

export const laboratoryNewsStatusesEnum = {
  DRAFT: { label: "Brouillon", color: "grey.dark" },
  PENDING_REVIEW: { label: "En relecture", color: "common.orange" },
  PUBLISHED: { label: "Publiée", color: "success.main" },
  WAITING: { label: "Différé", color: "common.white", borderColor: "success.main" },
  ARCHIVED: { label: "Désactivée", color: "primary.main" },
} as const satisfies LabNewsStatusEnum

export const labNewsStatusesReferential = referentialEnumToReferentialCodeList(
  laboratoryNewsStatusesEnum,
)
export type LabNewsStatusesName = keyof typeof laboratoryNewsStatusesEnum
